// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2hvac","inner":"Form_inner__-okit","range":"Form_range__4_9Un","name":"Form_name__3A-8t","actions":"Form_actions__14HjT"};